import {
  Form,
  Checkbox,
  Space,
  Row,
  Col,
  Button,
  Pagination,
  Modal,
  Input,
  List,
} from "antd";
import React, { useEffect, useState } from "react";
import { SearchOutlined } from "@ant-design/icons";
import { getserialesByserial } from "../../../services/seriales";

const Seriales = ({
  productoselect,
  seriales,
  agregarserial,
  arrayproductosfacturar,
  onFetchSeriales,
  current,
  totalpagina,
  setPagination,
}) => {
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [searchText, setSearchText] = useState("");
  const [loading, setLoading] = useState(false);
  const [filteredSeriales, setFilteredSeriales] = useState(seriales);
  const [selectAll, setSelectAll] = useState(false);

  const showModal = async () => {
    setLoading(true);
    try {
      await onFetchSeriales(productoselect?.id);
      setIsModalVisible(true);
      setFilteredSeriales(seriales);
      setSearchText("");
      setSelectAll(false);
    } catch (error) {
      console.error("Error fetching seriales:", error);
    } finally {
      setLoading(false);
    }
  };

  const handleCancel = () => {
    setIsModalVisible(false);
    setSearchText("");
    setFilteredSeriales(seriales);
    setSelectAll(false);
  };

  const handleSearch = async (e) => {
    const value = e.target.value;
    setSearchText(value);

    if (value.trim() === "") {
      setFilteredSeriales(seriales);
      return;
    }

    setLoading(true);
    try {
      const result = await getserialesByserial(value.trim());

      const filtered = productoselect?.id
        ? result.filter((s) => s.producto?.id === productoselect.id)
        : result;
      setFilteredSeriales(filtered);
    } catch (error) {
      setFilteredSeriales([]);
      console.error("Error buscando serial:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    setFilteredSeriales(seriales);
  }, [seriales]);

  const isSerialSelected = (serialId) => {
    return (
      Array.isArray(arrayproductosfacturar) &&
      arrayproductosfacturar.some(
        (item) =>
          Array.isArray(item.seriales) &&
          item.seriales.some((s) => s.id === serialId)
      )
    );
  };

  const handleSelectAll = (checked) => {
    setSelectAll(checked);

    if (checked) {
      filteredSeriales.forEach((serial) => {
        if (!isSerialSelected(serial.id)) {
          agregarserial(serial, true, false);
        }
      });

      if (filteredSeriales.length > 0) {
        setTimeout(() => {}, 100);
      }
    } else {
      filteredSeriales.forEach((serial) => {
        if (isSerialSelected(serial.id)) {
          agregarserial(serial, false, false);
        }
      });
    }
  };

  const areAllSelected = () => {
    return (
      filteredSeriales.length > 0 &&
      filteredSeriales.every((serial) => isSerialSelected(serial.id))
    );
  };

  const areSomeSelected = () => {
    return filteredSeriales.some((serial) => isSerialSelected(serial.id));
  };

  useEffect(() => {
    if (filteredSeriales.length > 0) {
      if (areAllSelected()) {
        setSelectAll(true);
      } else if (areSomeSelected()) {
        setSelectAll(false);
      } else {
        setSelectAll(false);
      }
    }
  }, [filteredSeriales, arrayproductosfacturar]);

  return (
    <Space direction="vertical" style={{ width: "100%" }}>
      <Button type="primary" onClick={showModal} loading={loading}>
        Ver Seriales
      </Button>

      <Modal
        title="Seriales Disponibles"
        open={isModalVisible}
        onCancel={handleCancel}
        width={800}
        footer={null}
      >
        <Input
          placeholder="Buscar serial"
          prefix={<SearchOutlined />}
          onChange={handleSearch}
          value={searchText}
          style={{ marginBottom: 16 }}
          allowClear
        />

        {filteredSeriales.length > 0 && (
          <div
            style={{
              marginBottom: 16,
              padding: "8px 0",
              borderBottom: "1px solid #f0f0f0",
            }}
          >
            <Checkbox
              checked={selectAll}
              indeterminate={areSomeSelected() && !areAllSelected()}
              onChange={(e) => handleSelectAll(e.target.checked)}
            >
              <strong>Seleccionar todos los seriales</strong>
            </Checkbox>
          </div>
        )}

        <List
          dataSource={filteredSeriales}
          renderItem={(item) => (
            <List.Item>
              <Checkbox
                onChange={(e) => agregarserial(item, e.target.checked)}
                checked={isSerialSelected(item.id)}
              >
                {item.serial}
              </Checkbox>
            </List.Item>
          )}
        />

        {searchText.trim() === "" && (
          <Pagination
            onChange={(page) => {
              setPagination((prev) => ({ ...prev, current: page }));
            }}
            current={current}
            total={totalpagina}
            pageSize={20}
            style={{ marginTop: 16, textAlign: "right" }}
          />
        )}
      </Modal>
    </Space>
  );
};

export default Seriales;
